import {
  IEditJobRequestParams,
  IGetJobLandingZoneRequest,
  IJobRuleSetState,
  ILandingJobState,
  IRulesetHistory,
  IUploadYamlParams,
} from '../../models/OperationsModels';
import { IPipelineInstanceDetailsResponse } from '../../models/PipelineModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServiceType, ServerType } from '../ServiceType.data';

const serviceType = ServiceType.DCP;
const serviceTypeLocal = ServiceType.None;

export class OperationsService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.dcp);

  private readonly serviceLocal: ApiServiceBase = new ApiService(
    serviceTypeLocal,
    ServerType.tangra,
  );

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public getJobLandingZones(
    data: IGetJobLandingZoneRequest,
  ): Promise<ILandingJobState[]> | ILandingJobState[] {
    return this.serviceLocal.get({
      route: [API_ROUTE.LANDING_ZONE.GET_LANDING_ZONE, data.projectId],
    });
  }

  public getJobRuleSet(
    projectId: string,
    landingZoneId?: string,
  ): Promise<IJobRuleSetState[]> | IJobRuleSetState[] {
    return this.dcaBackendService.get({
      route: [API_ROUTE.LANDING_ZONE.BASE, API_ROUTE.RULESET, projectId],
      query: { landingZoneId },
    });
  }

  public editJobRuleSet(
    editJobParams: IEditJobRequestParams,
  ): Promise<IJobRuleSetState[]> | IJobRuleSetState[] {
    return this.dcaBackendService.post(
      { route: [API_ROUTE.RULESET, editJobParams.ruleSetId] },
      editJobParams.parameters,
    );
  }

  public runJobRuleSet(
    runJobParams: IEditJobRequestParams,
  ): Promise<IJobRuleSetState[]> | IJobRuleSetState[] {
    return this.dcaBackendService.post(
      { route: [API_ROUTE.RULESET, API_ROUTE.RUN, runJobParams.ruleSetId] },
      runJobParams.parameters,
    );
  }

  public getRulesetHistory(rulesetId: string): Promise<IRulesetHistory[]> | IRulesetHistory[] {
    return this.service.get({ route: [API_ROUTE.RULESET_HISTORY, rulesetId] });
  }

  public getWorkflowDetails(
    workflowId: string,
  ): Promise<IPipelineInstanceDetailsResponse> | IPipelineInstanceDetailsResponse {
    return this.service.get({ route: [API_ROUTE.WORKFLOW.DETAILS, workflowId] });
  }

  public uploadCreateYaml(uploadCreateRuleSetParams: IUploadYamlParams): Promise<string> | string {
    const { uploadYamlPayload } = uploadCreateRuleSetParams;
    return this.dcaBackendService.postMultipart(
      {
        route: [API_ROUTE.LANDING_ZONE.ALTERNATE, API_ROUTE.RULESET],
      },
      [
        uploadYamlPayload.ruleSetYamlFile,
        uploadYamlPayload.jobYamlFile,
        uploadYamlPayload.projectId,
        uploadYamlPayload.cloudServiceProvider,
        uploadYamlPayload.landingZoneId,
      ],
    );
  }
}

const operationsService = new OperationsService();
export default operationsService;
